<template>
  <router-view />
</template>

<script>
export default {}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,
body,
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
	height: 100%;
  font-size: 16px;
}
</style>
